module.exports = __webpack_public_path__ + "img/023-storm-20.347bc523.svg";